var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropDownImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19368_33014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.856 3.71905L6.48101 7.21905L2.10601 3.71905C2.00344 3.63698 1.88572 3.5759 1.75955 3.53933C1.63339 3.50275 1.50126 3.49137 1.3707 3.50586C1.24014 3.52035 1.11371 3.56041 0.998633 3.62375C0.883556 3.6871 0.782082 3.77249 0.700006 3.87505C0.61793 3.97761 0.556858 4.09534 0.520279 4.2215C0.483699 4.34767 0.472328 4.4798 0.486814 4.61036C0.5013 4.74092 0.541359 4.86735 0.604705 4.98242C0.668052 5.0975 0.753444 5.19898 0.856006 5.28105L5.85601 9.28105C6.03337 9.42306 6.2538 9.50043 6.48101 9.50043C6.70821 9.50043 6.92864 9.42306 7.10601 9.28105L12.106 5.28105C12.3131 5.11529 12.4459 4.87404 12.4752 4.61036C12.5045 4.34668 12.4278 4.08219 12.262 3.87505C12.1799 3.77249 12.0785 3.6871 11.9634 3.62375C11.8483 3.56041 11.7219 3.52035 11.5913 3.50586C11.3276 3.4766 11.0631 3.55329 10.856 3.71905Z",
    fill: "#495057"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19368_33014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.480957 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownImg);
export default __webpack_public_path__ + "static/media/dropDownImg.6eac1e8cac3182284a76391ab307da43.svg";
export { ForwardRef as ReactComponent };